export default __webpack_public_path__ + "static/media/Procedures.c0bc0dbd.svg";